// Minimal CSV parser. Handles quoted fields, escaped quotes ("" inside ""), CR/LF.
// Returns { headers: string[], rows: string[][] }.
export function parseCSV(text) {
  if (!text) return { headers: [], rows: [] };
  // Strip UTF-8 BOM if present
  const clean = text.charCodeAt(0) === 0xFEFF ? text.slice(1) : text;

  const rows = [];
  let row = [];
  let cell = '';
  let inQ  = false;

  for (let i = 0; i < clean.length; i++) {
    const ch = clean[i];
    if (inQ) {
      if (ch === '"' && clean[i + 1] === '"') { cell += '"'; i++; }
      else if (ch === '"') { inQ = false; }
      else cell += ch;
    } else {
      if (ch === '"') inQ = true;
      else if (ch === ',') { row.push(cell); cell = ''; }
      else if (ch === '\n' || ch === '\r') {
        // End of line — skip \r\n pair
        if (ch === '\r' && clean[i + 1] === '\n') i++;
        row.push(cell); cell = '';
        // Skip empty rows
        if (row.length > 1 || row[0] !== '') rows.push(row);
        row = [];
      } else cell += ch;
    }
  }
  // Final field
  if (cell.length || row.length) { row.push(cell); rows.push(row); }

  if (rows.length === 0) return { headers: [], rows: [] };
  return { headers: rows[0].map(h => (h || '').trim()), rows: rows.slice(1) };
}

// QuickBooks Customer Center export commonly uses these header names.
// Map them to SteelOps customer fields. Keys are lowercase + trimmed for matching.
const HEADER_GUESS = {
  // name
  'customer':           'name',
  'customer name':      'name',
  'company':            'name',
  'name':               'name',
  'display name':       'name',
  'display name as':    'name',
  // address
  'bill to':            'addr',
  'billing address':    'addr',
  'address':            'addr',
  'street':             'addr',
  'full address':       'addr',
  'service address':    'addr',
  // phone
  'phone':              'phone',
  'main phone':         'phone',
  'phone number':       'phone',
  'work phone':         'phone',
  // email
  'email':              'email',
  'main email':         'email',
  'e-mail':             'email',
  // notes
  'notes':              'notes',
  'note':               'notes',
  'memo':               'notes',
  // tech assignment
  'tech':               'tech',
  'technician':         'tech',
  'assigned to':        'tech',
  // money
  'mrr':                'mrr',
  'monthly':            'mrr',
  'monthly fee':        'mrr',
};

// Returns { csvIndex -> tylers-fabricationField | null } guess based on CSV header names
export function guessMapping(headers) {
  const map = {};
  headers.forEach((h, i) => {
    const key = (h || '').toLowerCase().trim();
    map[i] = HEADER_GUESS[key] || null;
  });
  return map;
}

export const WAVEOPS_FIELDS = [
  { key: 'name',      label: 'Name *',       required: true },
  { key: 'addr',      label: 'Address' },
  { key: 'phone',     label: 'Phone' },
  { key: 'email',     label: 'Email' },
  { key: 'notes',     label: 'Notes' },
  { key: 'tech',      label: 'Tech assignment' },
  { key: 'mrr',       label: 'Monthly fee ($)' },
  { key: 'gate_code', label: 'Gate code' },
  { key: 'pool_gal',  label: 'Pool gallons' },
  { key: 'pets',      label: 'Pets' },
];
